import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "table table-sm table-bordered" }
const _hoisted_2 = { class: "text-end" }
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,} from "@/utils/funcoes";


interface IProps {
    itens: service.BoletoRetornoItemDTO[];
}

interface IGrupo {
    id: string;
    descricao: string;
    qtde: number;
    valorUnit: number;
    valorTotal: number;
    valorTotalDoctos: number;
    itens: service.BoletoRetornoItemDTO[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RetornoItensTarifas',
  props: {
    itens: {}
  },
  setup(__props: any) {


//vue
var props = __props;

var controle = reactive({
    itens: [] as service.BoletoRetornoItemDTO[],
    grupos: [] as IGrupo[],
    processando: false
});

onMounted(() => {
    controle.itens = props.itens;
    agrupar();
})

watch(() => props.itens ,(newVal) => {
        controle.itens = newVal;
        agrupar();
    }
);

const agrupar = async () => {

    controle.processando = true;
    controle.grupos = [] as IGrupo[];

    var grupos = Object.groupBy(props.itens, ({motivosRejeicao}) => motivosRejeicao as PropertyKey);

    for (const key in grupos){
        var itensGrupo = props.itens.filter(x => x.motivosRejeicao == key);

        var grupo: IGrupo = {
            id: key,
            descricao: itensGrupo[0].motivosRejeicao || 'Sem descrição',
            qtde: itensGrupo.length,
            valorUnit: itensGrupo[0].valorDespesasCobranca + itensGrupo[0].valorOutrasDespesas || 0,
            valorTotal: itensGrupo.reduce((acc, item) => acc + ((item.valorDespesasCobranca || 0) + (item.valorOutrasDespesas || 0)), 0),
            valorTotalDoctos: itensGrupo.reduce((acc, item) => acc + (item.valorDocumento || 0), 0),
            itens: itensGrupo
        };
            controle.grupos.push(grupo);
    }
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-12 col-12 fs-6 fw-bold" }, " Resumo das tarifas ", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Descrição"),
          _createElementVNode("th", { class: "text-end" }, "Qtde"),
          _createElementVNode("th", { class: "text-end" }, "Tarifa R$"),
          _createElementVNode("th", { class: "text-end" }, "Total Tarifa R$"),
          _createElementVNode("th", { class: "text-end" }, "Total Doctos R$")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).grupos, (item) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id
          }, [
            _createElementVNode("td", null, _toDisplayString(item.descricao), 1),
            _createElementVNode("td", _hoisted_2, _toDisplayString(item.qtde), 1),
            _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(f2dec)(item.valorUnit)), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(f2dec)(item.valorTotal)), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(f2dec)(item.valorTotalDoctos)), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("td", null, "Total", -1)),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(controle).grupos.reduce((acc, item) => acc + item.qtde, 0)), 1),
          _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
          _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(f2dec)(_unref(controle).grupos.reduce((acc, item) => acc + item.valorTotal, 0))), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(f2dec)(_unref(controle).grupos.reduce((acc, item) => acc + item.valorTotalDoctos, 0))), 1)
        ])
      ])
    ])
  ], 64))
}
}

})